<div class="ap-button-multi-action-wrapper">
    <button
        data-testid="action-button"
        class="ap-button ap-button-multi-action ap-button-left-part"
        type="button"
        [attr.aria-disabled]="isDisabled() ? isDisabled() : null"
        (click)="emitAction(actions()[0])"
    >
        {{ actions()[0] }}
    </button>

    <button
        data-testid="dropdown-button"
        class="ap-button ap-button-multi-action ap-button-right-part"
        type="button"
        [attr.aria-disabled]="isDisabled() ? isDisabled() : null"
        (click)="toggleDropdown()"
        [attr.aria-expanded]="isDropdownOpen"
        aria-haspopup="true"
    >
        @if (isDropdownOpen) {
            <ap-icon name="chevron-up"></ap-icon>
        }
        @if (!isDropdownOpen) {
            <ap-icon name="chevron-down"></ap-icon>
        }
    </button>

    @if (isDropdownOpen) {
        <div class="ap-button-dropdown" cdkTrapFocus cdkTrapFocusAutoCapture data-testid="dropdown">
            @for (action of actions().slice(1); track action) {
                <div
                    class="ap-button-dropdown__option"
                    data-testid="dropdown-option"
                    tabindex="0"
                    (keydown.enter)="emitAction(action, $event)"
                    (keydown.space)="emitAction(action, $event)"
                    (click)="emitAction(action, $event)"
                    (keydown.escape)="closeDropdown()"
                >
                    {{ action }}
                </div>
            }
        </div>
    }
</div>
